module.exports = __webpack_public_path__ + "assets/img/slaitinis-stogas-su-stoglangiu.acac0b88.jpg";